import React, { useState, useEffect } from 'react';
import { Box, Button, TextField } from '@mui/material';
import AppModal from "../../../../components/AppModal/AppModal";
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs, { Dayjs } from 'dayjs';
import { toast } from 'react-toastify';
import { useAuth } from '../../../../auth/auth';
import { updateAnnualLeave } from '../../../../api/apiCall';

interface EditHolidayFormProps {
  open: boolean;
  onClose: () => void;
  booking: any;
  profileInfo: any;
  getAnnualLeaves: () => void;
}

const EditHolidayForm: React.FC<EditHolidayFormProps> = ({
  open,
  onClose,
  booking,
  profileInfo,
  getAnnualLeaves,
}) => {
  const { state } = useAuth();
  const [startDate, setStartDate] = useState<Dayjs | null>(null);
  const [endDate, setEndDate] = useState<Dayjs | null>(null);
  const [notes, setNotes] = useState('');

  useEffect(() => {
    if (booking) {
      setStartDate(dayjs(booking.startDate));
      setEndDate(dayjs(booking.endDate));
      setNotes(booking.notes || '');
    }
  }, [booking]);

  const handleSave = async () => {
    if (!startDate || !endDate) {
      toast.warning('Please fill in both Start Date and End Date.');
      return;
    }

    const updatedBooking = {
      id: booking.id,
      userId: profileInfo.id,
      startDate: startDate.format('YYYY-MM-DD'),
      endDate: endDate.format('YYYY-MM-DD'),
      notes: notes?.trim() || undefined,
    };

    try {
      await updateAnnualLeave(state.user?.token, booking.id, updatedBooking);
      toast.success('Holiday updated successfully');
      getAnnualLeaves();
      onClose();
    } catch (error) {
      console.error('Failed to update annual leave:', error);
      toast.error('Error updating booking');
    }
  };

  return (
    <AppModal
      title={`Edit Holiday for ${profileInfo?.name} ${profileInfo?.surname}`}
      open={open}
      onCancel={onClose}
      footer={[
        <div style={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
          <Button variant="contained" sx={{ boxShadow: 'none', mb: 2 }} onClick={handleSave}>
            Save Changes
          </Button>
        </div>,
      ]}
    >
      <Box display="grid" gridTemplateColumns="1fr" gap={3}>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <DemoContainer components={['DatePicker', 'DatePicker']}>
            <DatePicker
              label="Start Date"
              value={startDate}
              onChange={(newValue) => setStartDate(newValue)}
              slotProps={{ textField: { size: 'small', fullWidth: true } }}
              format="DD/MM/YYYY"
            />
            <DatePicker
              label="End Date"
              value={endDate}
              onChange={(newValue) => setEndDate(newValue)}
              slotProps={{ textField: { size: 'small', fullWidth: true } }}
              format="DD/MM/YYYY"
            />
          </DemoContainer>
        </LocalizationProvider>
        <TextField
          label="Notes (optional)"
          variant="outlined"
          size="small"
          fullWidth
          value={notes}
          onChange={(e) => setNotes(e.target.value)}
        />
      </Box>
    </AppModal>
  );
};

export default EditHolidayForm;
